import React, { useState } from 'react';
import ConvertDate from '../../../../Helpers/ConvertDate';
import ModalService from '../../../../ModalService/ModalService';
import Formulario from '../components/Formulario';
import AlertSuccess from '../../../../../../../Services/Alerts/AlertSyE';
import AlertWarning from '../../../../../../../Services/Alerts/AlertWarning';
import TimbradoExitoso from '../components/TimbradoCanceladoExitoso';
import TimbradoErrores from '../components/TimbradoCanceladoErrores';

const ModalTimbrarCFDI = ({ nombreModulo, open, setOpen, nombre, setOpenLoading, setData, setMostrarTabla }) => {

    const [openAlertRSuccess, setOpenAlertRSuccess] = useState(false);
    const [openAlertRWarning, setOpenAlertRWarning] = useState(false);

    const cerrarModal = () => {
        setOpen(false);
    };

    const timbrarCFDI = data => {
        setOpenLoading(true);

        setTimeout(() => {
            setOpenLoading(false);
            setOpenAlertRSuccess(true);
            setTimeout(() => {
                setOpenAlertRSuccess(false);
                setOpenAlertRWarning(true);
            }, 3000);
        }, 3000);
    };

    const showTable = () => {
        setData({
            title: <strong>CVE- INTERNA</strong>,
            data: [
                {
                    numRegistro: 1,
                    status: 'Código 123: Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque vel felis a turpis fringilla vulputate et at dolor. Sed finibus facilisis accumsan. Duis bibendum a libero sed elementum. Nulla et magna quis elit scelerisque dapibus volutpat vitae lectus. Nulla mattis.',
                    numEmpleado: 112233,
                    nombre: 'Juan Pérez',
                    periodo: 9,
                    anio: 2020,
                    acumulado: 'Nómina',
                    fechaOperacion: ConvertDate(Date.now())
                },
                {
                    numRegistro: 2,
                    status: 'Código 123: Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque vel felis a turpis fringilla vulputate et at dolor. Sed finibus facilisis accumsan. Duis bibendum a libero sed elementum. Nulla et magna quis elit scelerisque dapibus volutpat vitae lectus. Nulla mattis.',
                    numEmpleado: 112234,
                    nombre: 'Carlos Ramírez',
                    periodo: 9,
                    anio: 2020,
                    acumulado: 'Nómina',
                    fechaOperacion: ConvertDate(Date.now())
                },
                {
                    numRegistro: 3,
                    status: 'Código 123: Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque vel felis a turpis fringilla vulputate et at dolor. Sed finibus facilisis accumsan. Duis bibendum a libero sed elementum. Nulla et magna quis elit scelerisque dapibus volutpat vitae lectus. Nulla mattis.',
                    numEmpleado: 112235,
                    nombre: 'Josué Cuervo',
                    periodo: 9,
                    anio: 2020,
                    acumulado: 'Nómina',
                    fechaOperacion: ConvertDate(Date.now())
                }
            ]
        });
        setMostrarTabla(true);
        cerrarModal();
    };

    return (
        <ModalService
            title="Timbrar CFDI"
            parentNode={nombreModulo}
            isOpen={open}
            onClose={cerrarModal}
            maxWidth="55%"
            minWidth="55%"
        >
            <div className="row">
                <div className="col-12">
                    <Formulario
                        nombre={nombre}
                        action={timbrarCFDI}
                    />
                </div>
            </div>
            <AlertSuccess show={openAlertRSuccess} setOpenAlertSyE={setOpenAlertRSuccess} title="Petición Exitosa" text={<TimbradoExitoso type="timbrados"/>} textbtnconfirm="Aceptar" type="success" />
            <AlertWarning show={openAlertRWarning} SetopenALert={setOpenAlertRWarning} title="Aviso" text={<TimbradoErrores type="timbrados"/>} textButtonAceptar="Ver Errores" action={showTable}/>
        </ModalService>
    );
}
 
export default ModalTimbrarCFDI;